import { render } from "./FiltersOverlay.vue?vue&type=template&id=05edc203"
import script from "./FiltersOverlay.vue?vue&type=script&lang=js"
export * from "./FiltersOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/FiltersOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05edc203"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05edc203', __exports__)) {
    api.reload('05edc203', __exports__)
  }
  
  module.hot.accept("./FiltersOverlay.vue?vue&type=template&id=05edc203", () => {
    api.rerender('05edc203', render)
  })

}


export default __exports__